import { apiUploadOrigin } from '@/common/config';
import { request } from '@/common/request';

/**
 * @param query
 * @description 上传
 */
export function ApiUploadFile(data) {
    return request({
        url: `${apiUploadOrigin}/upload/file`,
        data,
        passtoken: true,
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
    });
}
